var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "162px",
    height: "45px",
    viewBox: "0 0 162 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#008C4F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3247,27.4442 C52.3247,27.506 52.3247,27.5726 52.3295,27.6344 L52.3247,27.4442 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "161.691 7.55579 156.719 7.55579 156.719 37.3787 161.691 37.3787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.036,7.55579 L97.0637,7.55579 L97.0637,24.9581 C97.0685,26.3651 96.6692,27.7911 95.8373,29.0603 C93.5747,32.5017 88.9497,33.4524 85.5082,31.1898 C83.3359,29.7543 82.1523,27.3823 82.1523,24.9581 L82.1523,7.55579 L77.1802,7.55579 L77.1802,24.9581 C77.1849,28.9985 79.1528,32.9581 82.7797,35.3395 C88.5123,39.1137 96.2224,37.5261 99.9918,31.7887 C101.38,29.6782 102.045,27.3015 102.041018,24.9533 L102.036,24.9533 L102.036,7.55579 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1385,31.1852 C60.9662,29.7496 59.7826,27.3777 59.7826,24.9534 L59.7826,7.55115 L54.8105,7.55115 L54.8105,25.1436 C54.8533,27.7389 55.7042,30.2963 57.2871,32.4115 C57.9811,33.3337 58.8129,34.1751 59.7779,34.8976 C59.9823,35.0449 60.1867,35.1923 60.4006,35.3349 C62.4588,36.6944 64.7785,37.3551 67.0744,37.3789 L74.6894,37.3789 L74.6894,32.4068 L67.2312,32.4068 C65.8242,32.4163 64.403,32.017 63.1385,31.1852 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.152,9.60456 C140.629,5.9682 133.285,7.32292 129.377,12.5517 C128.536,11.4299 127.509,10.4174 126.269,9.60456 C120.536,5.83035 112.826,7.41799 109.057,13.1554 C107.669,15.2659 107.003,17.6426 107.007972,19.9908 L107.013,19.9908 L107.013,37.3883 L111.985,37.3883 L111.985,19.9908 C111.98,18.5838 112.379,17.1577 113.211,15.8886 C115.474,12.4471 120.099,11.4964 123.54,13.7591 C125.708,15.1851 126.887,17.5475 126.896,19.9623 C126.896,19.9718 126.896,19.9813 126.896,19.986 L126.901,19.986 L126.901,37.3835 L131.873,37.3835 L131.873,19.986 C131.873,19.9813 131.873,19.9718 131.873,19.967 C131.873,18.5648 132.268,17.1482 133.099,15.8838 C135.362,12.4424 139.987,11.4917 143.429,13.7543 C145.601,15.1898 146.784,17.5618 146.784,19.986 L146.784,37.3835 L151.757,37.3835 L151.757,19.986 C151.747,15.9504 149.779,11.9908 146.152,9.60456 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3446,37.2744 C30.58,37.2744 37.2561,30.5983 37.2561,22.3629 C37.2561,14.1275 30.58,7.45142 22.3446,7.45142 C14.1092,7.45142 7.43311,14.1275 7.43311,22.3629 C7.43311,30.5983 14.1092,37.2744 22.3446,37.2744 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1374,10.1038 C38.5104,10.1038 39.6234,8.99076 39.6234,7.61776 C39.6234,6.24476 38.5104,5.13171 37.1374,5.13171 C35.7644,5.13171 34.6514,6.24476 34.6514,7.61776 C34.6514,8.99076 35.7644,10.1038 37.1374,10.1038 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1374,10.1038 C38.5104,10.1038 39.6234,8.99076 39.6234,7.61776 C39.6234,6.24476 38.5104,5.13171 37.1374,5.13171 C35.7644,5.13171 34.6514,6.24476 34.6514,7.61776 C34.6514,8.99076 35.7644,10.1038 37.1374,10.1038 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3251,13.7354 C41.3155,13.7401 41.306,13.7497 41.2965,13.7544 C40.8497,14.0824 40.6833,14.6671 40.883,15.1852 C43.6875,22.4389 42.0809,30.9998 36.0678,36.7419 C28.429,44.0384 16.2413,44.0337 8.60726,36.7277 C0.516943,28.9844 0.421877,16.1454 8.31255,8.27847 C14.0737,2.53634 22.4682,1.06278 29.5889,3.84353 C30.1022,4.04317 30.6869,3.8768 31.0149,3.43474 C31.0196,3.42523 31.0292,3.41572 31.0339,3.40622 C31.514,2.75975 31.2573,1.82808 30.5063,1.53812 C22.2829,-1.67995 12.5336,0.150121 6.04517,7.04258 C-1.86452,15.4466 -2.03564,28.6754 5.66965,37.2696 C14.2971,46.8857 29.0993,47.2042 38.1308,38.2013 C44.6192,31.7366 46.3019,22.282 43.1884,14.2583 C42.8984,13.512 41.9715,13.2601 41.3251,13.7354 Z",
    id: "Path"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.68c6006b93a562fd4251822438e81402.svg";
export { ForwardRef as ReactComponent };